// @flow
function decodeFriend(p: Object = {}): Friend {
  return {
    avatar: p.avatar,
    firstName: p.first_name,
    id: p.id,
    lastName: p.last_name,
    status: p.relationship_status.id,
    username: p.name,
    sortOrder: 1
  };
}

export default decodeFriend;
